
import './App.css';
import HomePage from './Page/HomePage';

function App() {
  return (
    <div >
    <HomePage/>
    </div>
  );
}

export default App;
